import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { httpApiPostText } from "../../../../lib";
import { FaTrash } from "react-icons/fa";
import API_HOST, { HEADERS_JSON } from "../../../../ApiConfig";
import ConfirmModal from "../../../../components/ConfirmModal";

const FormularioPropiedadesPerfiles = (props: any) => {
  const [form, setForm]       = useState({ texto: "" });
  const [data, setData]       = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [confirm, setConfirm] = useState({
    show: false, mensaje: "", variante: "danger" as "danger"|"warning", accion: () => {}
  });
  const pedirConfirm = (msg: string, fn: () => void, v: "danger"|"warning" = "danger") =>
    setConfirm({ show: true, mensaje: msg, variante: v, accion: fn });
  const cerrarConfirm = () => setConfirm(c => ({ ...c, show: false }));

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await httpApiPostText(API_HOST, "POST", HEADERS_JSON, { valid: "selectProfiles" });
      if (!res?.message) return;
      const raw = res.message as string;
      const dta = JSON.parse(raw.substring(raw.indexOf("{")));
      if (dta?.payload) setData(dta.payload);
    } catch (e) {
      console.error("Error cargando perfils:", e);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { name: "Id", selector: (row: any) => row.id, sortable: true, width: "70px" },
    { name: "Descripción", selector: (row: any) => row.description, sortable: true, grow: 10 },
    {
      name: "Estado", width: "110px",
      cell: (row: any) => (
        <span
          className={`badge ${row.status === "activo" ? "bg-success" : "bg-secondary"}`}
          style={{ cursor: "pointer", fontSize: "12px", padding: "6px 10px" }}
          title="Click para cambiar estado"
          onClick={() => pedirConfirm(
            `¿Deseas cambiar el estado a ${row.status === "activo" ? "inactivo" : "activo"}?`,
            () => cambiarEstado(row.id), "warning"
          )}
        >
          {row.status === "activo" ? "Activo" : "Inactivo"}
        </span>
      ),
    },

  ];

  const pagOptions = { rowsPerPageText: "Filas por páginas", rangeSeparatorText: "de", selectAllRowsItem: true, selectAllRowsItemText: "Todos" };
  const conditionalRowStyles = [{ when: (row: any) => row.status === "inactivo", style: { backgroundColor: "#D6D5D5" } }];

  const onTextChange = (e: any) => {
    setErrorMsg("");
    setForm(f => ({ ...f, [e.target.id]: e.target.value }));
  };

  const onButtonClickAgregar = async (event: any) => {
    event.preventDefault();
    if (form.texto.trim() === "") return;
    setErrorMsg("");
    try {
      const res = await httpApiPostText(API_HOST, "POST", HEADERS_JSON,
        { valid: "newProfiles", description: form.texto.trim() }
      );
      const raw = res.message as string;
      const dta = JSON.parse(raw.substring(raw.indexOf("{")));
      if (dta.code === 2) {
        setErrorMsg(`Ya existe un perfil con el nombre "${form.texto.trim()}"`);
        return;
      }
      if (dta.code === 1) {
        setForm({ texto: "" });
        cargar();
      }
    } catch (e) {
      console.error("Error al agregar perfil:", e);
    }
  };

  const cambiarEstado = async (id: any) => {
    await httpApiPostText(API_HOST, "POST", HEADERS_JSON, { valid: "changeProfileStatus", id });
    cargar();
  };

  const eliminar = async (id: any) => {
    try {
      await httpApiPostText(API_HOST, "POST", HEADERS_JSON, { valid: "deleteProfile", id });
    } catch (e) { console.error("Error al eliminar perfil:", e); }
    cargar();
  };

  useEffect(() => { cargar(); }, []);

  return (
    <div className="container-fluid p-0">
      <div className="row mb-3">
        <div className="col col-lg-10">
          <label htmlFor="texto" className="form-label">Descripción</label>
          <input
            type="text"
            className={`form-control ${errorMsg ? "is-invalid" : ""}`}
            id="texto"
            onChange={onTextChange}
            value={form.texto}
            onKeyDown={(e) => { if (e.key === "Enter" && form.texto.trim()) onButtonClickAgregar(e); }}
          />
          {errorMsg && <div className="invalid-feedback d-block">⚠️ {errorMsg}</div>}
        </div>
        <div className="col-lg-2 d-flex align-items-start mt-4">
          <Button type="button" className="bg-dark w-100" onClick={onButtonClickAgregar}>
            Agregar
          </Button>
        </div>
      </div>

      <div className="mt-2">
        <p>Listado de Perfiles</p>
        <DataTable
          columns={columns}
          data={data}
          conditionalRowStyles={conditionalRowStyles}
          selectableRowsHighlight
          fixedHeader
          pagination
          highlightOnHover
          paginationComponentOptions={pagOptions}
          progressPending={loading}
          progressComponent={<div className="p-3 text-muted">Cargando...</div>}
          noDataComponent={<div className="p-3 text-muted">No hay registros</div>}
        />
      </div>

      <ConfirmModal
        show={confirm.show}
        mensaje={confirm.mensaje}
        variante={confirm.variante}
        onConfirm={() => { cerrarConfirm(); confirm.accion(); }}
        onCancel={cerrarConfirm}
      />
    </div>
  );
};

export default FormularioPropiedadesPerfiles;